module.exports = __webpack_public_path__ + "static/img/PALERMO_MAPLE.e631a04.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/PALERMO_MAPLE.jpg
// module id = +9zL
// module chunks = 0